import { forwardRef, HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

export type TypographyMaskProps = Omit<HTMLAttributes<HTMLSpanElement>, 'children'> & {
  children: JSX.Element
}

const TypographyMask = forwardRef<HTMLSpanElement, TypographyMaskProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <span
        ref={ref}
        data-label={children?.props?.children}
        className={cn(
          'relative inline-flex overflow-hidden',
          'after:font-roboto after:text-regular after:content-[attr(data-label)]',
          'after:absolute after:left-0 after:top-0 after:h-full after:w-full after:translate-y-[87%]',
          'after:transition-transform after:duration-300 after:ease-out-cubic',
          '[&>span]:my-0 [&>span]:inline-flex [&>span]:grow',
          '[&>span]:transition-transform [&>span]:duration-300 [&>span]:ease-out-cubic',
          'group-hover:after:translate-y-0 [&>span]:group-hover:-translate-y-[87%]',
          className
        )}
        {...props}
      >
        {children}
      </span>
    )
  }
)

export default TypographyMask
